/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { useState } from "react"
import { FlexContainer, Select, Stack, H2, Text } from "@carrotfertility/carotene"
import ArrowSubmitButton from "features/legacy-components/ArrowSubmitButton"
import { BackArrow } from "components/views/atoms/Molecules"
import { Progress } from "components/views/modal/Progress"
import { useStateMachine } from "components/context/stateMachine/StateMachineV2"
import { whoReceivedCareChoices } from "components/views/reimbursements/whoReceivedCareChoices"
import { useReimbursementContext } from "components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"

export const AboutThisExpenseWhoReceivedCare = (): JSX.Element => {
  const { send, back } = useStateMachine()
  const { updateWhoReceivedCare, state } = useReimbursementContext()
  const [answer, setAnswer] = useState(state.whoReceivedCare || null)
  const intl = useIntl()

  const handleChange = (value): void => {
    setAnswer(value)
  }

  const handleContinueClick = (): void => {
    updateWhoReceivedCare(answer)
    send("")
  }

  const formattedOptions = whoReceivedCareChoices.map((choice) => ({
    ...choice,
    label: intl.formatMessage(choice.label)
  }))

  return (
    <>
      <Progress
        numSteps={3}
        step={2}
        label={intl.formatMessage({ defaultMessage: "About This Expense" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <BackArrow onClick={back} />
      <Stack minHeight="500px" paddingTopBottom="huge">
        <H2 id="step-heading">
          <FormattedMessage defaultMessage="Who received the care or service?" />
        </H2>
        <Text>
          <FormattedMessage defaultMessage="If you have eligible expenses for more than one person, please upload them as separate submissions." />
        </Text>
        <Select
          aria-labelledby="step-heading"
          isSearchable={false}
          defaultValue={state.whoReceivedCare?.label ? (state.whoReceivedCare as any) : ""}
          onChange={handleChange}
          options={formattedOptions}
          placeholder={intl.formatMessage({ defaultMessage: "Select option" })}
        />
      </Stack>
      <FlexContainer paddingTopBottom="huge" justifyContent="flex-end">
        <ArrowSubmitButton enabled={Boolean(answer.value)} onClick={handleContinueClick}>
          <FormattedMessage defaultMessage="Continue" />
        </ArrowSubmitButton>
      </FlexContainer>
    </>
  )
}
